import React, {Component} from 'react';
import * as BB from "../../../components/BBComponent";
import {post} from "axios";
import notify from "devextreme/ui/notify";
import {Button, Container, Row, Col, Card, CardBody} from "reactstrap";
import ReactHtmlParser from "react-html-parser";

let answers = [];

class MailSurvey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gridData: undefined,
            QuestionsAll: [],
            existingAnswers: {},
            selectedTaskID: '',
            selectedTaskSurveyID: '',
            selectedTaskDescription: '',
            loading: false,
            DbNameURL: '',
            UserIDURL: '',
            SurveyIDURL: '',
            taskDetails: null,
            taskLoading: false,
        };
        this.answer = this.answer.bind(this);
        this.changeSelectionPriority = this.changeSelectionPriority.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
    }

    componentDidMount() {

        const urlData = this.props.location.search.replace('?', '').split('&');
        this.setState({
            DbNameURL: urlData[0].split('=')[1],
            UserIDURL: urlData[1].split('=')[1],
            SurveyIDURL: urlData[2].split('=')[1]
        })

        this.getData(urlData[0].split('=')[1], urlData[1].split('=')[1], urlData[2].split('=')[1]);
    }

    getData(DbName, UserID, SurveyID) {
        BB.FetchJSON(`api/TaskSurvey/GetDataForMail?DbName=${DbName}&UserID=${UserID}&SurveyID=${SurveyID}`, true).then(data => {
            if (data !== null) {
                this.setState({gridData: data[0]});
                this.answer(this.state.gridData.ID);
                this.setState({
                    selectedTaskID: this.state.gridData.TaskNumber.toString(),
                    selectedTaskSurveyID: this.state.gridData.ID
                });
            } else {
                this.setState({gridData: null});
            }
        });
    }

    answer(ID) {
        this.setState({loading: true});
        BB.FetchJSON('api/TaskSurvey/TaskAnswer?ID=' + ID).then(data => {
            var questions = [];
            var existingAnswers = {};

            // API yanıtının geçerli olduğunu kontrol et
            if (!data || !data.Survey || !data.Survey.SurveyQuestion) {
                console.error('API yanıtı geçersiz:', data);
                this.setState({loading: false});
                return;
            }

            // Mevcut cevapları al - DefaultLayout'taki yapıya göre güncellendi
            if (data.Survey.TaskSurveyReply && data.Survey.TaskSurveyReply.length > 0) {
                for (var reply of data.Survey.TaskSurveyReply) {
                    var question = data.Survey.SurveyQuestion.find(q => q.ID === reply.SurveyQuestionID);
                    
                    if (question) {
                        if (question.QuestionType === "text") {
                            var questionIndex = data.Survey.SurveyQuestion.findIndex(q => q.ID === reply.SurveyQuestionID);
                            existingAnswers[questionIndex] = {
                                answer: null,
                                comment: reply.Comment || "",
                                type: "text"
                            };
                        } else {
                            console.log("Choice cevabı bulundu:", reply);
                        }
                    }
                }
            }

            for (var i = 0; i < data.Survey.SurveyQuestion.length; i++) {
                const question = data.Survey.SurveyQuestion[i];
                
                if (question.QuestionType === "text") {
                    // Text tipi soru
                    questions.push({
                        Question: question.Question,
                        QuestionType: "text",
                        QuestionID: question.ID,
                        Placeholder: question.Placeholder || "Lütfen cevabınızı buraya yazın...",
                        HasComment: false,
                        Answer1: "",
                        Answer2: "",
                        Answer3: "",
                        Answer4: "",
                    });
                } else if (question.QuestionType === "choice") {
                    // Choice tipi soru - tek soru olarak oluştur, şıkları içinde tut
                    console.log(`Choice Soru ${i}: ${question.Question}, Şıklar:`, question.SurveyQuestionOption);
                    
                    if (question.SurveyQuestionOption && question.SurveyQuestionOption.length > 0) {
                        questions.push({
                            Question: question.Question,
                            QuestionType: "choice",
                            QuestionID: question.ID,
                            Placeholder: null,
                            HasComment: false,
                            // Şıkları doğru sırala: flex-direction: row-reverse ile hover efekti korunuyor
                            Answer1: question.SurveyQuestionOption[0]?.Option || "Çok Kötü", // 1. yıldız - en sol (Çok Kötü)
                            Answer2: question.SurveyQuestionOption[1]?.Option || "Kötü",     // 2. yıldız (Kötü)
                            Answer3: question.SurveyQuestionOption[2]?.Option || "İyi",      // 3. yıldız (İyi)
                            Answer4: question.SurveyQuestionOption[3]?.Option || "Çok İyi",  // 4. yıldız - en sağ (Çok İyi)
                            // Şık ID'lerini de tut
                            OptionID1: question.SurveyQuestionOption[0]?.ID || null,
                            OptionID2: question.SurveyQuestionOption[1]?.ID || null,
                            OptionID3: question.SurveyQuestionOption[2]?.ID || null,
                            OptionID4: question.SurveyQuestionOption[3]?.ID || null,
                            // Tüm şıkları array olarak da tut
                            Options: question.SurveyQuestionOption.map(opt => ({
                                ID: opt.ID,
                                Option: opt.Option
                            }))
                        });
                        console.log(`Oluşturulan choice soru:`, questions[questions.length - 1]);
                    }
                }
            }

            // Choice cevaplarını questions array'ine göre map et
            if (data.Survey.TaskSurveyReply && data.Survey.TaskSurveyReply.length > 0) {
                for (var reply of data.Survey.TaskSurveyReply) {
                    var question = data.Survey.SurveyQuestion.find(q => q.ID === reply.SurveyQuestionID);
                    
                    if (question && question.QuestionType === "choice") {
                        // Questions array'inde bu sorunun index'ini bul
                        const questionIndex = questions.findIndex(q => q.QuestionID === question.ID);
                        
                        if (questionIndex !== -1) {
                            // Bu sorunun hangi şığına ait olduğunu bul
                            const option = question.SurveyQuestionOption.find(opt => opt.ID === reply.SurveyQuestionOptionID);
                            if (option) {
                                // Şık index'ini bul (0-3 arası)
                                const optionIndex = question.SurveyQuestionOption.findIndex(opt => opt.ID === option.ID);
                                const selectedAnswer = question.SurveyQuestionOption[optionIndex]?.Option;
                                
                                existingAnswers[questionIndex] = {
                                    answer: selectedAnswer,
                                    comment: reply.Comment || "",
                                    type: "choice",
                                    selectedOptionID: reply.SurveyQuestionOptionID
                                };
                            }
                        }
                    }
                }
            }

            // Mevcut cevapları answers dizisine yükle
            answers = [];
            Object.keys(existingAnswers).forEach(questionIndex => {
                const existing = existingAnswers[questionIndex];
                const question = questions[questionIndex];
                
                if (existing.type === "text") {
                    // Text tipi sorular için
                    answers.push({
                        q: parseInt(questionIndex),
                        a: null,
                        surveyQuestionId: question.QuestionID,
                        surveyQuestionOptionId: null,
                        reply: "text",
                        comment: existing.comment,
                        type: existing.type
                    });
                } else {
                    // Choice tipi sorular için
                    answers.push({
                        q: parseInt(questionIndex),
                        a: existing.answer,
                        surveyQuestionId: question.QuestionID,
                        surveyQuestionOptionId: existing.selectedOptionID, // Doğru şık ID'si
                        reply: existing.answer,
                        comment: existing.comment,
                        type: existing.type
                    });
                }
            });

            this.setState({
                QuestionsAll: questions,
                existingAnswers: existingAnswers,
                loading: false
            });

        }).catch(error => {
            console.error('API çağrısında hata:', error);
            this.setState({loading: false});
        });
    }

    // Choice sorular için yıldız rating sistemi
    changeSelectionPriority(e) {
        const q = e.target.name.split('-')[0];
        const a = e.target.value;
        const question = this.state.QuestionsAll[q];

        // Seçilen şığın ID'sini bul
        let selectedOptionID = null;
        if (a === question.Answer1) selectedOptionID = question.OptionID1;
        else if (a === question.Answer2) selectedOptionID = question.OptionID2;
        else if (a === question.Answer3) selectedOptionID = question.OptionID3;
        else if (a === question.Answer4) selectedOptionID = question.OptionID4;

        // Mevcut cevabı answers array'inden çıkar
        answers = answers.filter(item => item.q !== parseInt(q) || item.type !== "choice");

        // Yeni choice cevabı ekle
        answers.push({
            q: parseInt(q),
            a: a,
            surveyQuestionId: question.QuestionID,
            surveyQuestionOptionId: selectedOptionID, // Doğru şık ID'si
            reply: a,
            comment: null,
            type: "choice"
        });

        // State'i güncelle
        const updatedExistingAnswers = { ...this.state.existingAnswers };
        updatedExistingAnswers[q] = { 
            answer: a, 
            comment: "", 
            type: "choice",
            selectedOptionID: selectedOptionID
        };
        this.setState({ existingAnswers: updatedExistingAnswers });
    }

    handleTextChange = (e) => {
        const q = e.target.id.split('-')[0];
        const text = e.target.value;

        // Mevcut cevabı bul ve sadece comment kısmını güncelle
        const existingAnswer = answers.find(item => item.q == q);
        const question = this.state.QuestionsAll[q];
        
        if (existingAnswer) {
            existingAnswer.comment = text;
            
            // Text tipi sorular için reply'ı "text" olarak ayarla
            if (question.QuestionType === "text") {
                existingAnswer.reply = "text";
                existingAnswer.a = null;
                existingAnswer.surveyQuestionOptionId = null;
                existingAnswer.type = "text";
            }
        } else {
            // Text tipi sorular için yeni cevap oluştur (boş olsa bile)
            if (question.QuestionType === "text") {
                answers.push({
                    q: parseInt(q),
                    a: null,
                    surveyQuestionId: question.QuestionID,
                    surveyQuestionOptionId: null,
                    reply: "text",
                    comment: text || "", // Boş string olarak kaydet
                    type: "text"
                });
            }
        }

        // state'i güncelle - comment kısmını güncelle
        const updatedExistingAnswers = { ...this.state.existingAnswers };
        if (!updatedExistingAnswers[q]) {
            updatedExistingAnswers[q] = { 
                answer: question.QuestionType === "text" ? null : null, 
                comment: text || "", 
                type: question.QuestionType || "choice" 
            };
        } else {
            updatedExistingAnswers[q].comment = text || "";
            if (question.QuestionType === "text") {
                updatedExistingAnswers[q].type = "text";
                updatedExistingAnswers[q].answer = null;
            }
        }

        this.setState({ existingAnswers: updatedExistingAnswers });
    }

    answerSave() {
        const formData = new FormData();
        let questionsAll = this.state.QuestionsAll;

        // Sadece choice tipi sorular için validation
        for (let i = 0; i < questionsAll.length; i++) {
            const question = questionsAll[i];
            
            if (question.QuestionType === "choice") {
                // Choice tipi sorular için yıldız puanı kontrol et
                const questionAnswer = answers.find(a => a.q === i && a.type === "choice");
                
                if (!questionAnswer || !questionAnswer.a) {
                    notify(`"${question.Question}" sorusu için lütfen yıldız puanı veriniz.`, "warning", 4000);
                    return;
                }
            }
            // Text tipi sorular için hiç validation yapmıyoruz - opsiyonel
        }

        formData.append("jsonText", JSON.stringify(answers));
        formData.append("TaskSurveyID", this.state.selectedTaskSurveyID);
        formData.append("TaskID", this.state.selectedTaskID);

        if (answers.length == 0) {
            notify("Anket cevapları boş geçilemez!", "warning", 4000);
            return;
        }
        
        this.setState({loading: true});

        post("api/TaskSurvey/TaskAnswer", formData, {
            headers: {
                "content-type": "multipart/form-data",
            },
        }).then((res) => {

            if (res.data.MessageStatus === true) {
                this.setState({
                    loading: false,
                });
                notify("Anket Tamamlandı!", "success", 1000);
                answers = [];
                this.getData(this.state.DbNameURL, this.state.UserIDURL, this.state.SurveyIDURL);
            } else {
                this.setState({
                    loading: false,
                });
                notify("Anket Oluşturma Hata! : " + res.data.Message, "error", 1000);
            }
        });
    }

    render() {
        return (
            <Container fluid style={{ padding: "20px", backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
                {
                    this.state.loading
                        ?
                        <div className="loading-hourglass-container">
                            <div className="loading-hourglass"></div>
                        </div>
                        :
                        this.state.gridData === null
                            ?
                            <div className="mail-survey-container text-center" style={{ padding: "50px" }}>
                                <Card style={{ maxWidth: "500px", margin: "0 auto" }}>
                                    <CardBody style={{ padding: "40px" }}>
                                        <h2 style={{ color: "#28a745", marginBottom: "20px" }}>✅ Anket Tamamlanmıştır!</h2>
                                        <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
                                            Bu anket daha önce tamamlanmıştır. Teşekkür ederiz.
                                        </p>
                                    </CardBody>
                                </Card>
                            </div>
                            :
                            <div className="mail-survey">
                                <Row>
                                    {/* Başlık */}
                                    <Col xs="12" className="mb-4">
                                        <Card style={{ backgroundColor: "#7CAED8", color: "white", border: "none" }}>
                                            <CardBody style={{ padding: "20px" }}>
                                                <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: "bold" }}>
                                                    {`${this.state.selectedTaskID} numaralı talep anketi`}
                                                </h2>
                                                <p style={{ margin: "10px 0 0 0", opacity: "0.9" }}>
                                                    Lütfen tüm soruları cevaplayınız
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </Col>

                                    {/* Anket Soruları */}
                                    <Col xs="12">
                                        <Card style={{ backgroundColor: "#fff", border: "1px solid #e3e6f0", borderRadius: "0.35rem" }}>
                                            <CardBody style={{ padding: "20px" }}>
                                                <div className="mb-3 pb-2" style={{ borderBottom: "1px solid #e3e6f0" }}>
                                                    <h6 className="mb-1" style={{ color: "#5a5c69", fontWeight: "700" }}>Anket Soruları</h6>
                                                    <small className="text-muted">Lütfen tüm soruları cevaplayınız</small>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                                    {this.state.QuestionsAll.map((item, index) => {
                                                        console.log(`Soru ${index}: QuestionType = ${item.QuestionType}, Question = ${item.Question}`);
                                                        return (
                                                            <div key={index} style={{
                                                                padding: "20px",
                                                                backgroundColor: "#f8f9fa",
                                                                borderRadius: "0.5rem",
                                                                border: "1px solid #e9ecef",
                                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                                            }}>
                                                                <div style={{
                                                                    display: "flex",
                                                                    alignItems: "flex-start",
                                                                    marginBottom: "15px",
                                                                    gap: "15px"
                                                                }}>
                                                                    <span style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "2rem",
                                                                        height: "2rem",
                                                                        backgroundColor: "#007bff",
                                                                        color: "white",
                                                                        borderRadius: "50%",
                                                                        fontSize: "1rem",
                                                                        fontWeight: "bold",
                                                                        flexShrink: "0",
                                                                        marginTop: "0.1rem"
                                                                    }}>
                                                                        {index + 1}
                                                                    </span>
                                                                    <span style={{
                                                                        fontSize: "1rem",
                                                                        fontWeight: "600",
                                                                        lineHeight: "1.5",
                                                                        flex: "1",
                                                                        wordWrap: "break-word",
                                                                        overflowWrap: "break-word",
                                                                        hyphens: "auto",
                                                                        color: "#495057"
                                                                    }}>
                                                                        {item.Question}
                                                                    </span>
                                                                </div>

                                                                {item.QuestionType === "choice" ? (
                                                                    <div className="rating d-flex justify-content-center mt-3">
                                                                        <input
                                                                            type="radio"
                                                                            id={`${index}-star1`}
                                                                            name={`${index}-rating`}
                                                                            value={item.Answer1}
                                                                            onClick={this.changeSelectionPriority}
                                                                        />
                                                                        <label className="star" htmlFor={`${index}-star1`} title={item.Answer1}></label>

                                                                        <input
                                                                            type="radio"
                                                                            id={`${index}-star2`}
                                                                            name={`${index}-rating`}
                                                                            value={item.Answer2}
                                                                            onClick={this.changeSelectionPriority}
                                                                        />
                                                                        <label className="star" htmlFor={`${index}-star2`} title={item.Answer2}></label>

                                                                        <input
                                                                            type="radio"
                                                                            id={`${index}-star3`}
                                                                            name={`${index}-rating`}
                                                                            value={item.Answer3}
                                                                            onClick={this.changeSelectionPriority}
                                                                        />
                                                                        <label className="star" htmlFor={`${index}-star3`} title={item.Answer3}></label>

                                                                        <input
                                                                            type="radio"
                                                                            id={`${index}-star4`}
                                                                            name={`${index}-rating`}
                                                                            value={item.Answer4}
                                                                            onClick={this.changeSelectionPriority}
                                                                        />
                                                                        <label className="star" htmlFor={`${index}-star4`} title={item.Answer4}></label>
                                                                    </div>
                                                                ) : item.QuestionType === "text" ? (
                                                                    // Text tipi sorular - serbest metin alanı
                                                                    <div>
                                                                        <textarea
                                                                            id={`${index}-comment`}
                                                                            className="form-control"
                                                                            rows="4"
                                                                            placeholder={item.Placeholder || "İsteğe bağlı olarak yorumunuzu yazabilirsiniz..."}
                                                                            value={this.state.existingAnswers[index] && this.state.existingAnswers[index].comment ? this.state.existingAnswers[index].comment : ""}
                                                                            onChange={this.handleTextChange}
                                                                            style={{
                                                                                fontSize: "0.9rem",
                                                                                border: "1px solid #e9ecef",
                                                                                borderRadius: "0.25rem",
                                                                                resize: "none",
                                                                                backgroundColor: "#fff",
                                                                            }}
                                                                        ></textarea>
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                                {/* Kaydet Butonu */}
                                                <div className="text-center mt-4">
                                                    <Button
                                                        onClick={() => this.answerSave()}
                                                        color={"primary"}
                                                        style={{
                                                            backgroundColor: "#00d4ff",
                                                            borderColor: "#00d4ff",
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            borderRadius: "25px",
                                                            padding: "12px 30px",
                                                            fontSize: "1rem",
                                                            boxShadow: "0 0 15px rgba(0, 212, 255, 0.6)",
                                                            textShadow: "0 0 5px rgba(255, 255, 255, 0.8)",
                                                            border: "2px solid #00d4ff",
                                                            transition: "all 0.3s ease"
                                                        }}
                                                    >
                                                        Kaydet
                                                    </Button>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                }
            </Container>
        );
    }
}

export default MailSurvey;
